














import { Component, Mixins } from "vue-property-decorator";
import DecoratorMixin from '../mixin';
import VueAvatar from "../../avatar.vue";

@Component({
  components: { 'vue-avatar': VueAvatar }
})
export default class UserDecorator extends Mixins(DecoratorMixin) {
  //
}
